// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/CRIBVEST Landscape Logo - Purple.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavBar_navBar__3JLcQ {
	top: 0;
	z-index: 1000;
	padding: 0 0 0 68px;
	height: 90px;
}

.NavBar_navBar___7v1Im {
	left: 0;
}

.NavBar_innerMain__3Sdim {
	max-width: 1240px !important;
}

.NavBar_autoLR__YKQl3 {
	left: auto;
	right: auto;
}

.NavBar_navBarPartial__kOQ-y {
	width: 41% !important;
}

.NavBar_navFixed__dvgRX {
	position: fixed;
}

.NavBar_logoContainer__GWd14 {
	/* margin-top: 44px; */
	width: 200px;
	height: 26.596px;
	flex-shrink: 0;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
}

.NavBar_navItemsContainer__NrrUk {
	padding-right: 68px;
	height: 100%;
}

.NavBar_partialWidth__5S-zy {
	width: calc(40.12px + 59%);
}

.NavBar_navItemsContainer__NrrUk.NavBar_partial__AOaTr {
	display: none !important;
}

.NavBar_navItems__-Dbz\\+ {
	border: 0 solid var(--white);
	transition: right 0.5s;
	gap: 10px;
}

.NavBar_doubleStrokes__X7uBo {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.NavBar_toggleSwitch__pGorD {
	display: none !important;
	z-index: -1;
	transition: none !important;
}

.NavBar_toggleSwitch__pGorD .NavBar_dInlineBlock__Yc8l3 {
	transition: none !important;
}

.NavBar_toggleSwitch__pGorD:hover {
	background-color: var(--lemon);
}

.NavBar_toggleSwitch2__XrQBx {
	display: none !important;
	position: absolute;
	height: 40px;
	width: 100px;
	font-weight: 600;
	font-size: 30px;
	background-color: var(--blue);
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
	border: 0 solid var(--blue);
	top: 100%;
	right: -100%;
	transition: right 1s linear;
	background-color: var(--lemon);
	color: var(--white);
	border: none;
}

.NavBar_showNavItems__mjaXi {
	top: 0% !important;
	right: 0% !important;
}

.NavBar_walletVal__T1UEA {
	text-overflow: ellipsis !important;
	overflow: hidden !important;
	white-space: nowrap !important;
	max-width: 100px !important;
}

.NavBar_isSmall__XAxKK {
	background-color: var(--blue) !important;
	border: none;
	border-left: 2px solid var(--blue);
}

.NavBar_exit__e5WC8 {
	position: absolute;
	top: auto;
	bottom: auto;
	right: 5px;
	transition: right 0.5s;
}

.NavBar_toggleSwitch2__XrQBx:hover .NavBar_exit__e5WC8 {
	right: -5px;
}

.NavBar_showNavItems__mjaXi .NavBar_toggleSwitch2__XrQBx {
	right: 0%;
}

.NavBar_twitch__ScymF {
	background-color: #fff !important;
}

.NavBar_container__00jP8 {
	padding-left: 100px;
	padding-right: 100px;
}

.NavBar_tinyNavBar__MLMoI {
	height: calc(100vh - 85px);
	padding-top: 25px;
	padding-bottom: 0;
	position: relative;
}

.NavBar_tinyNavItem__HaAZL {
	color: #000;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	padding: 21px 0;
	border-bottom: 1px solid #c4c4c4;
}

.NavBar_tinyFocused__XkjD8 {
	color: #f2be15 !important;
}

.NavBar_tinyGrayed__xCIfd {
	color: #ffffff7f;
}

.NavBar_tinyLogoutCon__db4ma .NavBar_tinyNavItem__HaAZL {
	border-top: 1px solid #c4c4c4;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
	.NavBar_container__00jP8 {
		padding-left: 42px;
		padding-right: 42px;
	}

	.NavBar_toggleSwitch__pGorD {
		display: flex !important;
	}

	.NavBar_toggleSwitch2__XrQBx {
		display: flex !important;
	}

	.NavBar_navBar__3JLcQ {
		padding: 0 0 0 30px;
	}

	.NavBar_navItemsContainer__NrrUk {
		width: initial !important;
		height: initial !important;
		padding-right: 30px;
	}

	.NavBar_navBarPartial__kOQ-y {
		width: 100% !important;
	}

	.NavBar_navItemsContainer__NrrUk.NavBar_partial__AOaTr {
		display: flex !important;
	}

	.NavBar_navItems__-Dbz\\+ {
		position: fixed;
		top: 0%;
		right: -100%;
		max-width: 100vw !important;
		max-height: 100vh !important;
		padding: 10px !important;
		background-color: #000;
	}

	.NavBar_toggleSwitch__pGorD {
		position: absolute;
		top: auto;
		bottom: auto;
		right: 30px;
	}

	.NavBar_logoContainer__GWd14 {
		width: 149px !important;
		height: 20px !important;
		flex-shrink: 0 !important;
	}
}

@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) {
	.NavBar_container__00jP8 {
		padding-left: 42px;
		padding-right: 42px;
	}

	.NavBar_toggleSwitch__pGorD {
		display: flex !important;
	}

	.NavBar_toggleSwitch2__XrQBx {
		display: flex !important;
	}

	.NavBar_navBar__3JLcQ {
		padding: 0 0 0 30px;
	}

	.NavBar_navItemsContainer__NrrUk {
		width: initial !important;
		height: initial !important;
		padding-right: 30px;
	}

	.NavBar_navBarPartial__kOQ-y {
		width: 100% !important;
	}

	.NavBar_navItemsContainer__NrrUk.NavBar_partial__AOaTr {
		display: flex !important;
	}

	.NavBar_navItems__-Dbz\\+ {
		position: fixed;
		top: 0%;
		right: -100%;
		max-width: 100vw !important;
		max-height: 100vh !important;
		padding: 10px !important;
		background-color: #000;
	}

	.NavBar_toggleSwitch__pGorD {
		position: absolute;
		top: auto;
		bottom: auto;
		right: 30px;
	}

	.NavBar_logoContainer__GWd14 {
		width: 149px !important;
		height: 20px !important;
		flex-shrink: 0 !important;
	}
}

@media only screen and (max-width: 820px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {
}

@media only screen and (max-width: 480px) {
	.NavBar_container__00jP8 {
		padding-left: 30px;
		padding-right: 30px;
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-width: 360px) and (min-width: 301px) {
}

@media only screen and (max-width: 300px) {
}

@media only screen and (max-width: 760px) and (min-width: 481px) {
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-height: 380px) and (min-height: 301px) {
}

@media only screen and (max-height: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/NavBar.module.css"],"names":[],"mappings":"AAAA;CACC,MAAM;CACN,aAAa;CACb,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,OAAO;AACR;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,gBAAgB;CAChB,cAAc;CACd,mDAAwE;CACxE,2BAA2B;CAC3B,wBAAwB;CACxB,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,4BAA4B;CAC5B,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,wBAAwB;CACxB,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,6BAA6B;CAC7B,2BAA2B;CAC3B,8BAA8B;CAC9B,2BAA2B;CAC3B,SAAS;CACT,YAAY;CACZ,2BAA2B;CAC3B,8BAA8B;CAC9B,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,kCAAkC;CAClC,2BAA2B;CAC3B,8BAA8B;CAC9B,2BAA2B;AAC5B;;AAEA;CACC,wCAAwC;CACxC,YAAY;CACZ,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;CACZ,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,0BAA0B;CAC1B,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA,yDAAyD;AACzD;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;CACpB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,eAAe;EACf,OAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;CACvB;;CAEA;EACC,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;CAC1B;AACD;;AAEA;AACA;;AAEA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;CACpB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,eAAe;EACf,OAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;CACvB;;CAEA;EACC,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;CAC1B;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;CACC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".navBar {\n\ttop: 0;\n\tz-index: 1000;\n\tpadding: 0 0 0 68px;\n\theight: 90px;\n}\n\n.navBar_ {\n\tleft: 0;\n}\n\n.innerMain {\n\tmax-width: 1240px !important;\n}\n\n.autoLR {\n\tleft: auto;\n\tright: auto;\n}\n\n.navBarPartial {\n\twidth: 41% !important;\n}\n\n.navFixed {\n\tposition: fixed;\n}\n\n.logoContainer {\n\t/* margin-top: 44px; */\n\twidth: 200px;\n\theight: 26.596px;\n\tflex-shrink: 0;\n\tbackground: url('../assets/images/CRIBVEST Landscape Logo - Purple.png');\n\tbackground-position: center;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n}\n\n.navItemsContainer {\n\tpadding-right: 68px;\n\theight: 100%;\n}\n\n.partialWidth {\n\twidth: calc(40.12px + 59%);\n}\n\n.navItemsContainer.partial {\n\tdisplay: none !important;\n}\n\n.navItems {\n\tborder: 0 solid var(--white);\n\ttransition: right 0.5s;\n\tgap: 10px;\n}\n\n.doubleStrokes {\n\twidth: 24px;\n\theight: 24px;\n\tflex-shrink: 0;\n}\n\n.toggleSwitch {\n\tdisplay: none !important;\n\tz-index: -1;\n\ttransition: none !important;\n}\n\n.toggleSwitch .dInlineBlock {\n\ttransition: none !important;\n}\n\n.toggleSwitch:hover {\n\tbackground-color: var(--lemon);\n}\n\n.toggleSwitch2 {\n\tdisplay: none !important;\n\tposition: absolute;\n\theight: 40px;\n\twidth: 100px;\n\tfont-weight: 600;\n\tfont-size: 30px;\n\tbackground-color: var(--blue);\n\tborder-top-left-radius: 5px;\n\tborder-bottom-left-radius: 5px;\n\tborder: 0 solid var(--blue);\n\ttop: 100%;\n\tright: -100%;\n\ttransition: right 1s linear;\n\tbackground-color: var(--lemon);\n\tcolor: var(--white);\n\tborder: none;\n}\n\n.showNavItems {\n\ttop: 0% !important;\n\tright: 0% !important;\n}\n\n.walletVal {\n\ttext-overflow: ellipsis !important;\n\toverflow: hidden !important;\n\twhite-space: nowrap !important;\n\tmax-width: 100px !important;\n}\n\n.isSmall {\n\tbackground-color: var(--blue) !important;\n\tborder: none;\n\tborder-left: 2px solid var(--blue);\n}\n\n.exit {\n\tposition: absolute;\n\ttop: auto;\n\tbottom: auto;\n\tright: 5px;\n\ttransition: right 0.5s;\n}\n\n.toggleSwitch2:hover .exit {\n\tright: -5px;\n}\n\n.showNavItems .toggleSwitch2 {\n\tright: 0%;\n}\n\n.twitch {\n\tbackground-color: #fff !important;\n}\n\n.container {\n\tpadding-left: 100px;\n\tpadding-right: 100px;\n}\n\n.tinyNavBar {\n\theight: calc(100vh - 85px);\n\tpadding-top: 25px;\n\tpadding-bottom: 0;\n\tposition: relative;\n}\n\n.tinyNavItem {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: normal;\n\tpadding: 21px 0;\n\tborder-bottom: 1px solid #c4c4c4;\n}\n\n.tinyFocused {\n\tcolor: #f2be15 !important;\n}\n\n.tinyGrayed {\n\tcolor: #ffffff7f;\n}\n\n.tinyLogoutCon .tinyNavItem {\n\tborder-top: 1px solid #c4c4c4;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n\t.container {\n\t\tpadding-left: 42px;\n\t\tpadding-right: 42px;\n\t}\n\n\t.toggleSwitch {\n\t\tdisplay: flex !important;\n\t}\n\n\t.toggleSwitch2 {\n\t\tdisplay: flex !important;\n\t}\n\n\t.navBar {\n\t\tpadding: 0 0 0 30px;\n\t}\n\n\t.navItemsContainer {\n\t\twidth: initial !important;\n\t\theight: initial !important;\n\t\tpadding-right: 30px;\n\t}\n\n\t.navBarPartial {\n\t\twidth: 100% !important;\n\t}\n\n\t.navItemsContainer.partial {\n\t\tdisplay: flex !important;\n\t}\n\n\t.navItems {\n\t\tposition: fixed;\n\t\ttop: 0%;\n\t\tright: -100%;\n\t\tmax-width: 100vw !important;\n\t\tmax-height: 100vh !important;\n\t\tpadding: 10px !important;\n\t\tbackground-color: #000;\n\t}\n\n\t.toggleSwitch {\n\t\tposition: absolute;\n\t\ttop: auto;\n\t\tbottom: auto;\n\t\tright: 30px;\n\t}\n\n\t.logoContainer {\n\t\twidth: 149px !important;\n\t\theight: 20px !important;\n\t\tflex-shrink: 0 !important;\n\t}\n}\n\n@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) {\n\t.container {\n\t\tpadding-left: 42px;\n\t\tpadding-right: 42px;\n\t}\n\n\t.toggleSwitch {\n\t\tdisplay: flex !important;\n\t}\n\n\t.toggleSwitch2 {\n\t\tdisplay: flex !important;\n\t}\n\n\t.navBar {\n\t\tpadding: 0 0 0 30px;\n\t}\n\n\t.navItemsContainer {\n\t\twidth: initial !important;\n\t\theight: initial !important;\n\t\tpadding-right: 30px;\n\t}\n\n\t.navBarPartial {\n\t\twidth: 100% !important;\n\t}\n\n\t.navItemsContainer.partial {\n\t\tdisplay: flex !important;\n\t}\n\n\t.navItems {\n\t\tposition: fixed;\n\t\ttop: 0%;\n\t\tright: -100%;\n\t\tmax-width: 100vw !important;\n\t\tmax-height: 100vh !important;\n\t\tpadding: 10px !important;\n\t\tbackground-color: #000;\n\t}\n\n\t.toggleSwitch {\n\t\tposition: absolute;\n\t\ttop: auto;\n\t\tbottom: auto;\n\t\tright: 30px;\n\t}\n\n\t.logoContainer {\n\t\twidth: 149px !important;\n\t\theight: 20px !important;\n\t\tflex-shrink: 0 !important;\n\t}\n}\n\n@media only screen and (max-width: 820px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 480px) {\n\t.container {\n\t\tpadding-left: 30px;\n\t\tpadding-right: 30px;\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n\n@media only screen and (max-width: 360px) and (min-width: 301px) {\n}\n\n@media only screen and (max-width: 300px) {\n}\n\n@media only screen and (max-width: 760px) and (min-width: 481px) {\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n\n@media only screen and (max-height: 380px) and (min-height: 301px) {\n}\n\n@media only screen and (max-height: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navBar": `NavBar_navBar__3JLcQ`,
	"navBar_": `NavBar_navBar___7v1Im`,
	"innerMain": `NavBar_innerMain__3Sdim`,
	"autoLR": `NavBar_autoLR__YKQl3`,
	"navBarPartial": `NavBar_navBarPartial__kOQ-y`,
	"navFixed": `NavBar_navFixed__dvgRX`,
	"logoContainer": `NavBar_logoContainer__GWd14`,
	"navItemsContainer": `NavBar_navItemsContainer__NrrUk`,
	"partialWidth": `NavBar_partialWidth__5S-zy`,
	"partial": `NavBar_partial__AOaTr`,
	"navItems": `NavBar_navItems__-Dbz+`,
	"doubleStrokes": `NavBar_doubleStrokes__X7uBo`,
	"toggleSwitch": `NavBar_toggleSwitch__pGorD`,
	"dInlineBlock": `NavBar_dInlineBlock__Yc8l3`,
	"toggleSwitch2": `NavBar_toggleSwitch2__XrQBx`,
	"showNavItems": `NavBar_showNavItems__mjaXi`,
	"walletVal": `NavBar_walletVal__T1UEA`,
	"isSmall": `NavBar_isSmall__XAxKK`,
	"exit": `NavBar_exit__e5WC8`,
	"twitch": `NavBar_twitch__ScymF`,
	"container": `NavBar_container__00jP8`,
	"tinyNavBar": `NavBar_tinyNavBar__MLMoI`,
	"tinyNavItem": `NavBar_tinyNavItem__HaAZL`,
	"tinyFocused": `NavBar_tinyFocused__XkjD8`,
	"tinyGrayed": `NavBar_tinyGrayed__xCIfd`,
	"tinyLogoutCon": `NavBar_tinyLogoutCon__db4ma`
};
export default ___CSS_LOADER_EXPORT___;
